/* VanillaGoods Baking Tools: general baking & conversions (10 tools). Needs vgt-core.js. */
(function (VGT) {
  'use strict';
  var U = VGT.U, D = VGT.D, ML = U.ML, G = U.G;

  /* --------------------------------------------------- shared recipe helpers --- */

  var PLURALS = { bean: 'beans', pod: 'pods', egg: 'eggs', yolk: 'yolks', white: 'whites', banana: 'bananas', lemon: 'lemons',
    lime: 'limes', orange: 'oranges', apple: 'apples', sheet: 'sheets', clove: 'cloves', packet: 'packets', envelope: 'envelopes',
    package: 'packages', can: 'cans', stick: 'sticks', block: 'blocks', bar: 'bars', jar: 'jars', bag: 'bags', box: 'boxes',
    container: 'containers', sachet: 'sachets', slice: 'slices', piece: 'pieces', drop: 'drops', pinch: 'pinches', dash: 'dashes',
    cup: 'cups', pkg: 'pkgs' };
  var SINGULARS = {};
  Object.keys(PLURALS).forEach(function (k) { SINGULARS[PLURALS[k]] = k; });
  /** Make the counted noun agree with the new amount ("1 vanilla bean" x2 -> "2 vanilla beans"). */
  function agree(text, n) {
    var many = n > 1 + 1e-9;
    return String(text).replace(/^([^,(]*?)([A-Za-z]+)(?=\s*(?:,|\(|$|\s+(?:split|halved|scraped|seeds|softened|beaten|chopped|sliced|peeled|zested|juiced|at|room|cut)\b))/, function (m, pre, w) {
      var lw = w.toLowerCase();
      if (many && PLURALS[lw]) return pre + matchCase(w, PLURALS[lw]);
      if (!many && SINGULARS[lw]) return pre + matchCase(w, SINGULARS[lw]);
      return m;
    });
  }
  function agreeWord(w, n) {
    var lw = w.toLowerCase(), many = n > 1 + 1e-9;
    if (many && PLURALS[lw]) return matchCase(w, PLURALS[lw]);
    if (!many && SINGULARS[lw]) return matchCase(w, SINGULARS[lw]);
    return w;
  }
  function matchCase(src, w) { return src[0] === src[0].toUpperCase() ? w[0].toUpperCase() + w.slice(1) : w; }

  /** A scaled amount in the same family of units the recipe used. */
  function amountText(p, q) {
    var u = p.unit;
    if (p.kind === 'mass') {
      var g = q * G[u];
      if (u === 'g' || u === 'mg') return U.gtxt(g);
      if (u === 'kg') return g < 1000 ? U.gtxt(g) : U.fmt(g / 1000, 2) + ' kg';
      if (u === 'oz') return U.oztxt(g);
      if (u === 'lb') return g / G.lb < 1 ? U.oztxt(g) : U.fmt(g / G.lb, 2) + ' lb';
    }
    if (p.kind === 'vol') {
      var ml = q * ML[u];
      if (u === 'ml' || u === 'l') return U.mltxt(ml);
      if (u === 'floz') return U.fmt(q, 1) + ' fl oz';
      if (u === 'pinch' || u === 'dash') return U.frac(q, [0, 0.5, 1]) + ' ' + agreeWord(u, q);
      return U.kvol(ml);
    }
    if (p.kind === 'stick') {
      var tb = q * 8;
      return U.frac(q, [0, 0.25, 0.5, 0.75, 1]) + ' ' + (q > 1 ? 'sticks' : 'stick') + (U.fracOk(q, 0.01, [0, 1]) ? '' : ' (' + U.fmt(tb, 1) + ' tbsp)');
    }
    return U.frac(q, [0, 1 / 4, 1 / 3, 1 / 2, 2 / 3, 3 / 4, 1]);
  }
  function innerText(p, f) {
    if (!p.inner) return '';
    var pi = { unit: p.inner.unit, kind: p.inner.kind };
    return '(' + amountText(pi, p.inner.qty * f) + (p.inner.tail ? ' ' + p.inner.tail : '') + ')';
  }
  function splitAmt(t) {
    var m = String(t).match(/^([\d\s\u00bc-\u00be\u2150-\u215e.,]+)(.*)$/);
    return m ? [m[1].trim(), m[2].trim()] : [t, ''];
  }
  var EGG_WORD = { egg: 'egg', 'egg-white': 'egg white', 'egg-yolk': 'egg yolk' };

  /** Scale one parsed line by f: {text, grams, eggs, kind}. */
  function scaleLine(p, f) {
    if (p.qty == null) return { text: p.raw.trim(), grams: null, same: true };
    var q = p.qty * f, q2 = p.qty2 != null ? p.qty2 * f : null;
    var grams = U.lineGrams(p, q);
    var eggKey = p.ing && EGG_WORD[p.ing.key] && p.kind === 'count' && !p.inner ? p.ing.key : '';
    if (eggKey) {
      var size = U.eggSize(p), word = EGG_WORD[eggKey];
      var sizeWord = size === 'large' ? 'large ' : size === 'xl' ? 'extra-large ' : size + ' ';
      var et = U.eggText(q, word).replace(/(\d+) (egg)/, '$1 ' + sizeWord + '$2');
      var tail = p.rest.replace(/^(?:(?:extra[- ])?large|medium|small|jumbo|whole)\s+/i, '').replace(/^(?:egg(?:\s+(?:whites?|yolks?))?s?)\b\s*/i, '').replace(/^,\s*/, ', ');
      return { text: et + (tail ? (tail[0] === ',' ? '' : ' ') + tail : ''), grams: grams, egg: q, eggFrac: Math.abs(q - Math.round(q)) > 0.15 };
    }
    var amt = amountText(p, q);
    if (q2 != null) {
      var lo = splitAmt(amt), hi = splitAmt(amountText(p, q2));
      amt = lo[1] === hi[1] ? lo[0] + '\u2013' + hi[0] + (hi[1] ? ' ' + hi[1] : '') : amt + '\u2013' + amountText(p, q2);
    }
    var head;
    if (p.kind === 'count') {
      var cw = p.unitText ? agreeWord(p.unitText, q) + ' ' : '';
      head = p.innerFirst ? amt + ' ' + innerText(p, 1) + ' ' + cw : amt + ' ' + cw + (p.inner ? innerText(p, 1) + ' ' : '');
      return { text: (head + agree(p.rest, q)).replace(/\s+/g, ' ').trim(), grams: grams };
    }
    head = amt + ' ' + (p.inner ? innerText(p, f) + ' ' : '');
    return { text: (head + p.rest).replace(/\s+/g, ' ').trim(), grams: grams };
  }
  VGT.scaleLine = scaleLine;
  VGT.lines = function (text) { return String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean).slice(0, 80); };

  function wtxt(g) { return g == null ? '\u2013' : U.sys() === 'metric' ? U.gtxt(g) : U.oztxt(g) + ' \u00b7 ' + U.gtxt(g); }

  /* ======================================================== 1. cups to grams === */

  var QUICK_CUPS = [['0.25', '\u00bc'], ['0.333', '\u2153'], ['0.5', '\u00bd'], ['0.667', '\u2154'], ['0.75', '\u00be'], ['1', '1'], ['2', '2']];
  var MEASURE_NOTE = {
    flour: 'Weights assume you spoon the flour into the cup and level it off. Scooping straight from the bag packs in up to 25% more.',
    sugar: 'Brown sugar is packed firmly into the cup; confectioners\u2019 sugar is spooned in, unsifted.',
    fat: 'A US stick of butter is \u00bd cup, 8 tablespoons or 113 g.',
    choc: 'Chips and chopped chocolate vary with piece size; weigh them when it matters, as in ganache.',
    leaven: 'Small amounts are where a scale helps least and measuring spoons work best; level each spoon with a knife.'
  };

  VGT.tool('cups-to-grams-converter', {
    name: 'Cups to Grams Converter',
    fields: [
      { id: 'mode', type: 'seg', label: 'Convert', value: 'one', options: [['one', 'One ingredient'], ['recipe', 'A whole recipe']] },
      { id: 'ing', type: 'sel', label: 'Ingredient', value: 'ap-flour', options: D.ingOptions(), show: function (v) { return v.mode === 'one'; }, w: 'full' },
      { id: 'amt', type: 'num', label: 'Amount', value: '1', min: 0, quick: QUICK_CUPS, show: function (v) { return v.mode === 'one'; },
        unit: { id: 'u', value: 'cup', options: [{ g: 'Volume', o: U.VOL_UNITS }, { g: 'Weight', o: U.MASS_UNITS }, { g: 'Pieces', o: [['each', 'pieces (eggs, sticks, cans)']] }] } },
      { id: 'list', type: 'text', label: 'Paste your ingredients, one per line', rows: 9, show: function (v) { return v.mode === 'recipe'; },
        value: '2 1/4 cups all-purpose flour\n1 cup (2 sticks) unsalted butter, softened\n3/4 cup granulated sugar\n3/4 cup packed brown sugar\n2 large eggs\n2 tsp vanilla extract\n1 tsp baking soda\n1 tsp salt\n2 cups chocolate chips' }
    ],
    compute: function (v) {
      if (v.mode === 'recipe') return recipeToGrams(v.list);
      var ing = D.ING[v.ing], d = D.density(v.ing), u = v.u, q = v.amt, g;
      if (u === 'each') {
        if (!ing.each) return { error: ing.name + ' isn\u2019t sold in pieces. Choose a volume or weight unit.' };
        g = q * ing.each;
      } else g = U.UNIT_KIND[u] === 'mass' ? q * G[u] : q * ML[u] * d;
      var ml = g / d, fromVol = U.UNIT_KIND[u] === 'vol';
      var uname = { cup: 'cup', tbsp: 'tbsp', tsp: 'tsp', floz: 'fl oz', ml: 'mL', l: 'L', g: 'g', kg: 'kg', oz: 'oz', lb: 'lb', each: ing.eachName || 'piece' }[u];
      if (u === 'each' && q > 1) uname = uname.replace(/^(\w+)/, '$1s');
      var what = (u === 'cup' ? U.frac(q, [0, 1 / 8, 1 / 4, 1 / 3, 3 / 8, 1 / 2, 5 / 8, 2 / 3, 3 / 4, 7 / 8, 1]) : U.fmt(q, 3)) + ' ' + (u === 'cup' && q > 1 ? 'cups' : uname) + (u === 'each' ? '' : ' ' + ing.name.toLowerCase());
      var cards = fromVol || u === 'each'
        ? [{ label: what, value: U.gtxt(g), sub: U.oztxt(g) + ' by weight' },
           { label: 'In cups and spoons', value: U.kvol(ml), sub: U.mltxt(ml) }]
        : [{ label: what, value: U.kvol(ml), sub: U.mltxt(ml) + ' by volume' },
           { label: 'In grams and ounces', value: U.gtxt(g), sub: U.oztxt(g) }];
      if (ing.each && u !== 'each') cards.push({ label: 'In ' + ing.eachName + 's', value: U.fmt(g / ing.each, 2), sub: U.gtxt(ing.each) + ' each' });
      var rows = [[1 / 8, '\u215b cup'], [1 / 4, '\u00bc cup'], [1 / 3, '\u2153 cup'], [1 / 2, '\u00bd cup'], [2 / 3, '\u2154 cup'], [3 / 4, '\u00be cup'], [1, '1 cup']]
        .map(function (r) { var gg = r[0] * ML.cup * d; return { cells: [r[1], U.gtxt(gg), U.oztxt(gg)], hl: u === 'cup' && Math.abs(q - r[0]) < 0.01 }; });
      rows.unshift({ cells: ['1 tsp', U.gtxt(ML.tsp * d), U.oztxt(ML.tsp * d)], hl: u === 'tsp' && q === 1 }, { cells: ['1 tbsp', U.gtxt(ML.tbsp * d), U.oztxt(ML.tbsp * d)], hl: u === 'tbsp' && q === 1 });
      var res = { cards: cards, tables: [{ title: ing.name + ': cups and spoons by weight', head: ['Measure', 'Grams', 'Ounces'], rows: rows }], notes: [] };
      if (MEASURE_NOTE[ing.group]) res.notes.push(MEASURE_NOTE[ing.group]);
      res.notes.push('One US cup is 236.6 mL. Weights for dry ingredients follow King Arthur Baking\u2019s ingredient weight chart; liquids use their measured density.');
      return res;
    }
  });

  function recipeToGrams(text) {
    var lines = VGT.lines(text), rows = [], out = [], n = 0, total = 0, missing = 0;
    if (!lines.length) return { error: 'Paste at least one ingredient line, like \u201c1 cup sugar\u201d.' };
    lines.forEach(function (l) {
      var p = U.parseLine(l), g = U.lineGrams(p);
      if (p.qty == null) { rows.push({ cells: [l, '\u2013', 'No amount'], muted: true }); out.push(l); return; }
      if (g == null) {
        missing++;
        rows.push({ cells: [l, '?', p.ing ? 'Pieces vary' : 'Unknown ingredient'], muted: true }); out.push(l); return;
      }
      n++; total += g;
      var isMass = p.kind === 'mass';
      rows.push([l, U.gtxt(g), isMass ? 'Already by weight' : U.oztxt(g)]);
      out.push(U.gtxt(g) + ' ' + (p.kind === 'count' && p.unitText ? p.unitText + ' ' : '') + p.rest + (p.kind === 'count' && p.ing && p.ing.each ? ' (' + U.frac(p.qty, [0, 0.25, 0.5, 0.75, 1]) + ')' : ''));
    });
    var res = {
      cards: [{ label: 'Lines converted to grams', value: n + ' of ' + lines.length, sub: missing ? missing + ' need a weight from you' : 'Every line with an amount' },
        { label: 'Total weight', value: U.gtxt(total), sub: U.oztxt(total) }],
      tables: [{ title: 'Your recipe by weight', head: ['As written', 'Grams', 'Ounces'], rows: rows }],
      copy: out.join('\n'),
      notes: ['Copy gives you the whole list in grams, ready to paste back into your recipe.',
        'Kosher salt varies by brand: we use Diamond Crystal unless the line says Morton.']
    };
    if (missing) res.warns = ['We couldn\u2019t weigh ' + missing + ' line' + (missing > 1 ? 's' : '') + '. Check the spelling, or weigh those ingredients yourself.'];
    return res;
  }

  /* ===================================================== 2. recipe scaling ==== */

  VGT.tool('recipe-scaling-calculator', {
    name: 'Recipe Scaling Calculator',
    copyLabel: 'Copy list',
    fields: [
      { id: 'by', type: 'seg', label: 'Scale by', value: 'serv', options: [['serv', 'Servings'], ['mult', 'Multiplier'], ['pan', 'Pan size']] },
      { id: 'from', type: 'num', label: 'Recipe makes (servings)', value: '12', min: 0.01, show: function (v) { return v.by === 'serv'; } },
      { id: 'to', type: 'num', label: 'Servings you want', value: '24', min: 0.01, show: function (v) { return v.by === 'serv'; } },
      { id: 'mult', type: 'num', label: 'Multiply by', value: '2', min: 0.01, max: 100, w: 'full', show: function (v) { return v.by === 'mult'; },
        quick: [['0.5', '\u00bd\u00d7'], ['1.5', '1\u00bd\u00d7'], ['2', '2\u00d7'], ['3', '3\u00d7'], ['4', '4\u00d7']] },
      { id: 'pa', type: 'sel', label: 'Pan in the recipe', value: 'r8', options: D.panOptions(), show: function (v) { return v.by === 'pan'; } },
      { id: 'pan', type: 'num', label: 'How many', value: '2', min: 1, max: 12, show: function (v) { return v.by === 'pan'; } },
      { id: 'pb', type: 'sel', label: 'Your pan', value: 'q13', options: D.panOptions(), show: function (v) { return v.by === 'pan'; } },
      { id: 'pbn', type: 'num', label: 'How many', value: '1', min: 1, max: 12, show: function (v) { return v.by === 'pan'; } },
      { id: 'list', type: 'text', label: 'Ingredients, one per line', rows: 9,
        value: '240 g all-purpose flour\n200 g sugar\n115 g butter, softened\n2 large eggs\n120 mL milk\n10 mL vanilla extract\n1 1/2 tsp baking powder\n1/4 tsp salt',
        help: 'Paste from any recipe. We read cups, spoons, grams, ounces, sticks and eggs.' },
      { id: 'wt', type: 'chk', label: 'Show the weight of each ingredient', value: true, more: true }
    ],
    moreLabel: 'Display options',
    compute: function (v) {
      var f, label;
      if (v.by === 'serv') { f = v.to / v.from; label = U.fmt(v.from, 2) + ' \u2192 ' + U.fmt(v.to, 2) + ' servings'; }
      else if (v.by === 'mult') { f = v.mult; label = 'Recipe \u00d7 ' + U.fmt(f, 3); }
      else {
        var pa = D.pan(v.pa), pb = D.pan(v.pb);
        f = (pb.cups * v.pbn) / (pa.cups * v.pan);
        label = U.fmt(v.pan, 0) + ' \u00d7 ' + pa.name + ' \u2192 ' + U.fmt(v.pbn, 0) + ' \u00d7 ' + pb.name;
      }
      var lines = VGT.lines(v.list);
      if (!lines.length) return { error: 'Paste your ingredients, one per line.' };
      var rows = [], out = [], eggFrac = false, leaven = false, total = 0, known = 0;
      lines.forEach(function (l) {
        var p = U.parseLine(l), s = scaleLine(p, f);
        if (s.grams != null) { total += s.grams; known++; }
        if (s.eggFrac) eggFrac = true;
        if (p.ing && /baking-powder|baking-soda|instant-yeast|active-yeast|salt|kosher/.test(p.ing.key)) leaven = true;
        out.push(s.text);
        var cells = [l, s.text];
        if (v.wt) cells.push(s.grams != null ? wtxt(s.grams) : '\u2013');
        rows.push({ cells: cells, muted: s.same });
      });
      var head = ['Original', 'Scaled'];
      if (v.wt) head.push('Weight');
      var notes = [];
      if (eggFrac) notes.push('Eggs are rounded to what you can crack: a yolk is about a third of an egg and a white about two thirds. For exact results, beat the eggs and weigh what the Weight column shows.');
      if (leaven && (f >= 2.5 || f <= 0.4)) notes.push('Leaveners, salt and yeast are scaled exactly. For batches 3\u00d7 or larger, many bakers start with a little less and taste or test.');
      if (v.by !== 'pan' && Math.abs(f - 1) > 0.05) notes.push(f > 1 ? 'Bake a bigger batch in more pans of the original size and the baking time stays about the same. One larger, deeper pan bakes longer.' : 'Use a smaller pan so the batter stays about as deep as before, and start checking for doneness a few minutes early.');
      var res = {
        cards: [{ label: 'Multiply every ingredient by', value: U.mult(f), sub: label },
          { label: 'Scaled batch weighs', value: U.mass(total), sub: known < lines.length ? known + ' of ' + lines.length + ' lines we could weigh' : 'all ' + lines.length + ' ingredients' }],
        tables: [{ title: 'Your scaled ingredients', head: head, rows: rows, num: false }],
        copy: 'Scaled ' + U.mult(f) + ' (' + label + ')\n' + out.join('\n'),
        notes: notes
      };
      if (f > 8 || f < 0.125) res.warns = ['That\u2019s a big change. Recipes rarely scale perfectly past 4\u00d7 or below \u00bc; make a test batch first.'];
      res.links = v.by === 'pan' ? [{ href: '/pages/baking-time-calculator?a=' + v.pa + '&an=' + v.pan + '&b=' + v.pb + '&bn=' + v.pbn, text: 'Estimate the new baking time' }]
        : [{ href: '/pages/baking-pan-size-converter', text: 'Find a pan for the new batch' }, { href: '/pages/baking-time-calculator', text: 'Estimate the baking time' }];
      return res;
    }
  });

  /* ================================================== 3. pan size converter === */

  function panFields(prefix, label, dflt, dfltN) {
    var isC = function (v) { return v[prefix] === 'custom'; };
    return [
      { id: prefix, type: 'sel', label: label, value: dflt, options: D.panOptions(null, true) },
      { id: prefix + 'n', type: 'num', label: 'How many', value: dfltN, min: 1, max: 12 },
      { id: prefix + 's', type: 'seg', label: 'Shape', value: 'round', options: [['round', 'Round'], ['rect', 'Square or rectangle']], show: isC },
      { id: prefix + 'd', type: 'num', label: 'Diameter', value: '9', min: 1, max: 40, show: function (v) { return isC(v) && v[prefix + 's'] === 'round'; }, w: 'third' },
      { id: prefix + 'l', type: 'num', label: 'Length', value: '9', min: 1, max: 40, show: function (v) { return isC(v) && v[prefix + 's'] === 'rect'; }, w: 'third' },
      { id: prefix + 'w', type: 'num', label: 'Width', value: '9', min: 1, max: 40, show: function (v) { return isC(v) && v[prefix + 's'] === 'rect'; }, w: 'third' },
      { id: prefix + 'h', type: 'num', label: 'Depth', value: '2', min: 0.5, max: 12, show: isC, w: 'third' },
      { id: prefix + 'u', type: 'sel', label: 'Measured in', value: 'in', options: U.LEN_UNITS, show: isC, w: 'third' }
    ];
  }
  function panFrom(v, prefix) {
    var u = v[prefix + 'u'];
    return D.pan(v[prefix], { shape: v[prefix + 's'], d: U.toIn(v[prefix + 'd'], u), l: U.toIn(v[prefix + 'l'], u), w: U.toIn(v[prefix + 'w'], u), h: U.toIn(v[prefix + 'h'], u) });
  }
  VGT.panFields = panFields;
  VGT.panFrom = panFrom;

  VGT.tool('baking-pan-size-converter', {
    name: 'Baking Pan Size Converter',
    fields: panFields('a', 'Pan in the recipe', 'r9', '2').concat(panFields('b', 'Your pan', 'q13', '1')).concat([
      { id: 't', type: 'num', label: 'Recipe\u2019s baking time (minutes)', value: '28', min: 1, max: 300, optional: true, more: true,
        help: 'Optional: we\u2019ll estimate the time in your pan.' }
    ]),
    moreOpen: true,
    moreLabel: 'Baking time',
    compute: function (v) {
      var a = panFrom(v, 'a'), b = panFrom(v, 'b');
      var va = a.cups * v.an, vb = b.cups * v.bn, f = vb / va;
      var areaA = a.area * v.an, areaB = b.area * v.bn;
      var fillA = D.fillFor(a), dA = fillA * a.depth;
      var dSame = dA * areaA / areaB, dScaled = fillA * b.depth;
      var fits = Math.abs(f - 1) <= 0.15;
      var cards = [
        { label: 'Multiply the recipe by', value: U.mult(f), tone: fits ? 'ok' : '',
          sub: (fits ? 'Close enough to use the recipe as it is: your pan' : 'Your pan') + (v.bn > 1 ? 's hold ' : ' holds ') + U.pct(Math.abs(f - 1) * 100) + (f >= 1 ? ' more' : ' less') + (fits ? '' : ' than the recipe\u2019s') },
        { label: 'Recipe\u2019s pans hold', value: U.vol(va * ML.cup), sub: U.vol(va * ML.cup, true).replace(/^[^(]*\(|\)$/g, '') },
        { label: 'Your pans hold', value: U.vol(vb * ML.cup), sub: U.vol(vb * ML.cup, true).replace(/^[^(]*\(|\)$/g, '') }
      ];
      var notes = [], warns = [];
      if (!fits) notes.push('Unscaled, the same batter would sit ' + U.pct(Math.abs(dSame / dA - 1) * 100) + (dSame > dA ? ' deeper' : ' shallower') + ' in your pan' + (dSame > dA ? ', so it bakes longer and may overflow.' : ', so it bakes faster and comes out thinner.'));
      if (dSame / b.depth > 0.8 && !fits && f < 1) warns.push('Without scaling, the batter would fill your pan more than 80%: it will likely overflow. Scale the recipe down or use a second pan.');
      var tables = [];
      if (isFinite(v.t) && v.t > 0) {
        var tS = D.bakeTime(v.t, a, dA, b, dScaled), tU = D.bakeTime(v.t, a, dA, b, dSame);
        tables.push({ title: 'Estimated baking time in your pan', head: ['If you\u2026', 'Batter depth', 'Bake about'], rows: [
          ['Scale the recipe (' + U.mult(f) + ')', U.len(dScaled, 1), rangeMin(tS)],
          ['Use the recipe as it is', U.len(dSame, 1), rangeMin(tU)]
        ], note: 'Same oven temperature. Start checking 5 to 10 minutes before the shorter time.' });
      }
      // other pans that hold about the same
      var alt = [];
      D.PAN_LIST.forEach(function (p) {
        if (p.shape === 'pie' || p.shape === 'muffin' || p.key === a.key) return;
        [1, 2, 3].forEach(function (n) {
          var r = p.cups * n / va;
          if (Math.abs(r - 1) <= 0.12 && alt.length < 9 && !(n > 1 && alt.some(function (x) { return x.k === p.key; }))) alt.push({ k: p.key, cells: [n + ' \u00d7 ' + p.name, U.mult(r)] });
        });
      });
      var cupcakes = Math.round(D.recipeFill(a) * va * ML.cup / 52);
      alt.push({ cells: ['Standard cupcakes (2\u2154 full)', 'about ' + cupcakes] });
      tables.push({ title: 'Pans that hold about the same as the recipe\u2019s', head: ['Pans', 'Recipe \u00d7'], rows: alt.map(function (x) { return x.cells; }) });
      return {
        cards: cards, warns: warns, tables: tables, notes: notes.concat(['Volumes are to the rim, from standard pan charts; real pans vary by up to 10%. Fill yours with water from a measuring cup to know its exact volume.']),
        links: fits ? [] : [{ href: '/pages/recipe-scaling-calculator?by=mult&mult=' + U.fmt(f, 2).replace(/,/g, ''), text: 'Scale your ingredients by ' + U.mult(f) }]
      };
    }
  });
  function rangeMin(t) { return U.fmt(Math.round(t * 0.92), 0) + '\u2013' + U.fmt(Math.round(t * 1.08), 0) + ' min'; }
  VGT.rangeMin = rangeMin;

  /* ========================================== 4. ingredient substitutions ===== */
  /* base: the amount one row of parts replaces. parts: [amount per base, unit, text]. Units: cup tbsp tsp oz each. */
  var SUBS = [
    ['buttermilk', 'Buttermilk', 1, 'cup', [
      ['Milk + lemon juice', [[1, 'tbsp', 'lemon juice or white vinegar'], [15 / 16, 'cup', 'milk (to make the full amount)']], 'Stir and let it stand 5 to 10 minutes until it thickens slightly. Best for pancakes, biscuits and cakes.'],
      ['Yogurt + milk', [[0.75, 'cup', 'plain yogurt'], [0.25, 'cup', 'milk']], 'Whisk smooth. Thick and tangy, the closest match for flavor.'],
      ['Milk + cream of tartar', [[1.75, 'tsp', 'cream of tartar'], [1, 'cup', 'milk']], 'Whisk the cream of tartar into a little of the milk first so it doesn\u2019t clump.'],
      ['Kefir', [[1, 'cup', 'plain kefir']], 'A one-for-one swap.']]],
    ['egg', 'Eggs (large)', 1, 'each', [
      ['Flax egg', [[1, 'tbsp', 'ground flaxseed'], [3, 'tbsp', 'water']], 'Stir and rest 5 minutes until gel-like. Binds well in cookies, muffins and quick breads; doesn\u2019t lift.'],
      ['Chia egg', [[1, 'tbsp', 'chia seeds (ground if you can)'], [3, 'tbsp', 'water']], 'Rest 10 minutes. Like flax, it binds rather than lifts.'],
      ['Aquafaba', [[3, 'tbsp', 'liquid from canned chickpeas']], 'Whisk until foamy. Works in cakes and cookies; 2 tbsp replaces one egg white, and it whips like whites.'],
      ['Applesauce', [[0.25, 'cup', 'unsweetened applesauce']], 'Adds moisture; best in brownies, muffins and spice cakes. Add \u00bc tsp baking powder per egg for lift.'],
      ['Mashed banana', [[0.25, 'cup', 'ripe mashed banana']], 'Moist and dense, with a banana flavor.'],
      ['Plain yogurt', [[0.25, 'cup', 'plain yogurt']], 'Good in muffins and cakes.']], 'Replacing more than two eggs changes a recipe\u2019s structure a lot. Choose a recipe written to be egg-free when eggs do most of the work.'],
    ['butter', 'Butter', 1, 'cup', [
      ['Vegetable oil', [[0.875, 'cup', 'vegetable oil']], 'For recipes that use melted butter. Butter is about 80% fat, so use \u215e as much oil. Not for creaming with sugar.'],
      ['Coconut oil', [[1, 'cup', 'coconut oil']], 'Solid for creaming, melted for melted-butter recipes. Refined coconut oil tastes neutral.'],
      ['Vegan butter sticks', [[1, 'cup', 'plant-based butter']], 'A one-for-one swap in most baking.'],
      ['Shortening', [[1, 'cup', 'vegetable shortening'], [0.5, 'tsp', 'salt (if the recipe used salted butter)']], 'Bakes taller and softer with less flavor.'],
      ['Half applesauce', [[0.5, 'cup', 'butter'], [0.5, 'cup', 'unsweetened applesauce']], 'Cuts fat in muffins and quick breads; the texture turns cakier.']]],
    ['milk', 'Milk', 1, 'cup', [
      ['Dry milk + water', [[1 / 3, 'cup', 'nonfat dry milk'], [1, 'cup', 'water']], 'Whisk until dissolved.'],
      ['Evaporated milk + water', [[0.5, 'cup', 'evaporated milk'], [0.5, 'cup', 'water']], 'Tastes a little richer.'],
      ['Half-and-half + water', [[0.75, 'cup', 'half-and-half'], [0.25, 'cup', 'water']], 'Close to whole milk.'],
      ['Plant milk', [[1, 'cup', 'unsweetened soy, oat or almond milk']], 'Soy and oat milk brown and set most like dairy.']]],
    ['heavy-cream', 'Heavy cream', 1, 'cup', [
      ['Milk + butter', [[0.75, 'cup', 'whole milk'], [0.25, 'cup', 'melted butter']], 'For baking and sauces. It won\u2019t whip.'],
      ['Half-and-half + butter', [[0.875, 'cup', 'half-and-half'], [2, 'tbsp', 'melted butter']], 'For baking and sauces. It won\u2019t whip.'],
      ['Coconut cream', [[1, 'cup', 'chilled coconut cream (the solid part)']], 'Whips like cream and is dairy-free; it tastes of coconut.']]],
    ['sour-cream', 'Sour cream', 1, 'cup', [
      ['Greek yogurt', [[1, 'cup', 'plain whole-milk Greek yogurt']], 'The best match in cakes, dips and frostings.'],
      ['Plain yogurt', [[1, 'cup', 'plain whole-milk yogurt']], 'A little thinner.'],
      ['Cr\u00e8me fra\u00eeche', [[1, 'cup', 'cr\u00e8me fra\u00eeche']], 'Richer and milder.']]],
    ['half-half', 'Half-and-half', 1, 'cup', [
      ['Milk + cream', [[0.5, 'cup', 'whole milk'], [0.5, 'cup', 'heavy cream']], 'An exact match.'],
      ['Milk + butter', [[0.875, 'cup', 'whole milk'], [2, 'tbsp', 'melted butter']], 'For cooking and baking.']]],
    ['evap-milk', 'Evaporated milk', 1, 'cup', [
      ['Reduced milk', [[2.25, 'cup', 'whole milk, simmered down to the amount you need']], 'Simmer gently, stirring, about 25 minutes.'],
      ['Half-and-half', [[1, 'cup', 'half-and-half']], 'Slightly richer.']]],
    ['condensed-milk', 'Sweetened condensed milk', 1.25, 'cup', [
      ['From dry milk', [[1, 'cup', 'nonfat dry milk'], [2 / 3, 'cup', 'sugar'], [1 / 3, 'cup', 'boiling water'], [3, 'tbsp', 'melted butter']], 'Blend until smooth and thick. 1\u00bc cups equals one 14-oz can.'],
      ['Reduced milk', [[2, 'cup', 'whole milk'], [2 / 3, 'cup', 'sugar']], 'Simmer, stirring often, until reduced to the amount needed, about 45 minutes.']]],
    ['brown-sugar', 'Brown sugar', 1, 'cup', [
      ['Sugar + molasses (light)', [[1, 'cup', 'granulated sugar'], [1, 'tbsp', 'molasses']], 'Mix with a fork or in a food processor. Use 2 tbsp molasses for dark brown sugar.'],
      ['Coconut sugar', [[1, 'cup', 'coconut sugar']], 'Similar caramel flavor; a little drier.']]],
    ['powdered-sugar', 'Confectioners\u2019 sugar', 1, 'cup', [
      ['Blended granulated sugar', [[9 / 16, 'cup', 'granulated sugar'], [1, 'tsp', 'cornstarch']], 'Blend in a dry blender 1 to 2 minutes until powdery, then sift. Makes about 1 cup.']]],
    ['cake-flour', 'Cake flour', 1, 'cup', [
      ['Flour + cornstarch', [[0.875, 'cup', 'all-purpose flour (1 cup minus 2 tbsp)'], [2, 'tbsp', 'cornstarch']], 'Sift together twice. By weight: 105 g flour + 15 g cornstarch per cup.']]],
    ['sr-flour', 'Self-rising flour', 1, 'cup', [
      ['Flour + baking powder + salt', [[1, 'cup', 'all-purpose flour'], [1.5, 'tsp', 'baking powder'], [0.25, 'tsp', 'salt']], 'Whisk well before using.']]],
    ['bread-flour', 'Bread flour', 1, 'cup', [
      ['All-purpose flour', [[1, 'cup', 'all-purpose flour']], 'Bread will be a little softer and less chewy; hold back 1 to 2 tbsp of the water.'],
      ['Flour + vital wheat gluten', [[1, 'cup', 'all-purpose flour'], [1.5, 'tsp', 'vital wheat gluten']], 'Closest to bread flour\u2019s chew.']]],
    ['baking-powder', 'Baking powder', 1, 'tsp', [
      ['Baking soda + cream of tartar', [[0.25, 'tsp', 'baking soda'], [0.5, 'tsp', 'cream of tartar']], 'Mix right before using; it acts fast, so bake promptly.'],
      ['Baking soda + buttermilk', [[0.25, 'tsp', 'baking soda'], [0.5, 'cup', 'buttermilk or yogurt (use it in place of \u00bd cup of the recipe\u2019s liquid)']], 'Good in pancakes, biscuits and cakes.']], 'More options in our Baking Powder & Soda Substitution Guide.'],
    ['baking-soda', 'Baking soda', 1, 'tsp', [
      ['Baking powder', [[3, 'tsp', 'baking powder']], 'Lifts well but browns less and can taste a little tangy.']]],
    ['cornstarch', 'Cornstarch (for thickening)', 1, 'tbsp', [
      ['All-purpose flour', [[2, 'tbsp', 'all-purpose flour']], 'Cook a few minutes longer to lose the raw flour taste; sauces turn opaque.'],
      ['Arrowroot', [[1, 'tbsp', 'arrowroot']], 'Glossy and clear; add at the end and don\u2019t boil hard.'],
      ['Potato starch', [[1, 'tbsp', 'potato starch']], 'Thickens fast; keep it below a boil.'],
      ['Tapioca starch', [[2, 'tbsp', 'tapioca starch']], 'Clear and glossy; good in fruit pies.']]],
    ['honey', 'Honey', 1, 'cup', [
      ['Sugar + water', [[1.25, 'cup', 'granulated sugar'], [0.25, 'cup', 'water or other liquid from the recipe']], 'A standard swap; you\u2019ll lose honey\u2019s flavor.'],
      ['Maple syrup', [[1, 'cup', 'maple syrup']], 'Thinner and a little less sweet.']]],
    ['corn-syrup', 'Light corn syrup', 1, 'cup', [
      ['Sugar syrup', [[1, 'cup', 'granulated sugar'], [0.25, 'cup', 'water']], 'Heat until the sugar dissolves. Fine in pies and sauces; in candy it can crystallize.'],
      ['Golden syrup', [[1, 'cup', 'golden syrup']], 'A one-for-one swap with a light caramel taste.']]],
    ['molasses', 'Molasses', 1, 'cup', [
      ['Dark brown sugar + water', [[0.75, 'cup', 'dark brown sugar, packed'], [0.25, 'cup', 'water']], 'Milder flavor.'],
      ['Dark corn syrup or honey', [[1, 'cup', 'dark corn syrup or honey']], 'Lighter in flavor and color.']]],
    ['unsweetened-choc', 'Unsweetened chocolate', 1, 'oz', [
      ['Cocoa + fat', [[3, 'tbsp', 'unsweetened cocoa powder'], [1, 'tbsp', 'butter or oil']], 'Melt the butter and stir in the cocoa.']]],
    ['semisweet-choc', 'Semisweet chocolate', 1, 'oz', [
      ['Unsweetened chocolate + sugar', [[0.5, 'oz', 'unsweetened chocolate'], [1, 'tbsp', 'granulated sugar']], 'Melt together.'],
      ['Chocolate chips', [[1, 'oz', 'semisweet chocolate chips']], 'Chips hold their shape; melt gently.']]],
    ['dutch-cocoa', 'Dutch-process cocoa', 3, 'tbsp', [
      ['Natural cocoa + baking soda', [[3, 'tbsp', 'natural cocoa powder'], [0.125, 'tsp', 'baking soda']], 'The soda balances natural cocoa\u2019s acidity.'],
      ['Unsweetened chocolate', [[1, 'oz', 'unsweetened chocolate'], [-1, 'tbsp', 'butter or oil (use this much less)']], 'Melt it in; reduce the recipe\u2019s fat a little.']]],
    ['vanilla-extract', 'Vanilla extract', 1, 'tsp', [
      ['Vanilla bean paste', [[1, 'tsp', 'vanilla bean paste']], 'One for one, with visible seeds.'],
      ['Vanilla bean', [[1 / 3, 'each', 'vanilla bean (scrape the seeds)']], 'One bean equals about 1 tablespoon of extract.'],
      ['Vanilla powder', [[1, 'tsp', 'pure vanilla powder']], 'Good in dry mixes and where alcohol isn\u2019t wanted.'],
      ['Double-fold extract', [[0.5, 'tsp', 'double-fold vanilla extract']], 'Twice the strength, so half the amount.']]],
    ['vanilla-bean', 'Vanilla bean', 1, 'each', [
      ['Vanilla extract', [[1, 'tbsp', 'pure vanilla extract']], 'Add it off the heat or with the fat; heat dulls it.'],
      ['Vanilla bean paste', [[1, 'tbsp', 'vanilla bean paste']], 'Gives you the seeds without splitting a pod.']]],
    ['lemon-juice', 'Lemon juice', 1, 'tbsp', [
      ['Lime juice', [[1, 'tbsp', 'lime juice']], 'A one-for-one swap.'],
      ['Vinegar', [[1, 'tbsp', 'white or apple cider vinegar']], 'For acidity in baking, not for flavor.']]],
    ['cream-tartar', 'Cream of tartar', 1, 'tsp', [
      ['Lemon juice (egg whites)', [[3, 'tsp', 'lemon juice or white vinegar']], 'For whipping egg whites; add with the sugar.'],
      ['Baking powder (leavening)', [[2, 'tsp', 'baking powder (and leave out \u00bd tsp of the baking soda)']], 'When the cream of tartar works with baking soda, as in snickerdoodles.']]],
    ['pumpkin-spice', 'Pumpkin pie spice', 1, 'tsp', [
      ['Spice mix', [[0.5, 'tsp', 'ground cinnamon'], [0.25, 'tsp', 'ground ginger'], [0.125, 'tsp', 'ground nutmeg'], [0.125, 'tsp', 'ground allspice or cloves']], 'Mix well; make a jar of it to keep.']]]
  ];
  var SUB = {};
  SUBS.forEach(function (s) { SUB[s[0]] = { key: s[0], name: s[1], base: s[2], unit: s[3], opts: s[4], note: s[5] || '' }; });
  var SUB_UNITS = { cup: [['cup', 'cups'], ['tbsp', 'tablespoons'], ['tsp', 'teaspoons'], ['ml', 'milliliters']],
    tbsp: [['tbsp', 'tablespoons'], ['tsp', 'teaspoons'], ['cup', 'cups'], ['ml', 'milliliters']],
    tsp: [['tsp', 'teaspoons'], ['tbsp', 'tablespoons'], ['g', 'grams']],
    oz: [['oz', 'ounces'], ['g', 'grams']],
    each: [['each', 'whole']] };

  function partText(qty, unit, text) {
    var neg = qty < 0, q = Math.abs(qty), s;
    if (unit === 'each') s = U.frac(q, [0, 1 / 4, 1 / 3, 1 / 2, 2 / 3, 3 / 4, 1]);
    else if (unit === 'oz') s = U.sys() === 'metric' ? U.gtxt(q * G.oz) : U.fmt(q, 2) + ' oz (' + U.gtxt(q * G.oz) + ')';
    else s = U.sys() === 'metric' && unit === 'cup' ? U.mltxt(q * ML[unit]) + ' (' + U.kvol(q * ML[unit]) + ')' : U.kvol(q * ML[unit]);
    return (neg ? 'minus ' : '') + s + ' ' + text;
  }

  VGT.tool('ingredient-substitution-calculator', {
    name: 'Ingredient Substitution Calculator',
    fields: [
      { id: 'what', type: 'sel', label: 'Ingredient you\u2019re out of', value: 'buttermilk', w: 'full',
        options: SUBS.map(function (s) { return [s[0], s[1]]; }).sort(function (a, b) { return a[1].localeCompare(b[1]); }) },
      { id: 'amt', type: 'num', label: 'Amount the recipe calls for', value: '1', min: 0.01, max: 1000,
        unit: { id: 'u', value: 'cup', options: [{ g: 'Volume', o: [['cup', 'cups'], ['tbsp', 'tablespoons'], ['tsp', 'teaspoons'], ['ml', 'milliliters']] }, { g: 'Weight', o: [['oz', 'ounces'], ['g', 'grams']] }, { g: 'Count', o: [['each', 'whole (eggs, beans)']] }] } }
    ],
    compute: function (v) {
      var s = SUB[v.what];
      var baseUnits = s.unit === 'each' ? 'each' : s.unit === 'oz' ? 'mass' : 'vol';
      var uKind = v.u === 'each' ? 'each' : U.UNIT_KIND[v.u];
      if (baseUnits !== uKind) {
        var want = baseUnits === 'each' ? 'whole' : baseUnits === 'mass' ? 'ounces or grams' : 'cups or spoons';
        return { error: 'Enter ' + s.name.toLowerCase() + ' in ' + want + '.' };
      }
      var n; // how many "base" portions the recipe needs
      if (baseUnits === 'each') n = v.amt / s.base;
      else if (baseUnits === 'mass') n = v.amt * G[v.u] / (s.base * G.oz);
      else n = v.amt * ML[v.u] / (s.base * ML[s.unit]);
      var lists = s.opts.map(function (o) {
        return { title: o[0], items: o[1].map(function (p) { return partText(p[0] * n, p[1], p[2]); }).concat(o[2] ? [{ html: '<em>' + o[2] + '</em>' }] : []) };
      });
      var amtTxt = baseUnits === 'each' ? U.frac(v.amt, [0, 0.25, 0.5, 0.75, 1]) + ' ' + s.name.toLowerCase().replace(/s? \(large\)$/, v.amt > 1 ? 's' : '') :
        baseUnits === 'mass' ? U.fmt(v.amt, 2) + ' ' + (v.u === 'g' ? 'g' : 'oz') + ' ' + s.name.toLowerCase() : U.kvol(v.amt * ML[v.u]) + ' ' + s.name.toLowerCase();
      var res = {
        cards: [{ label: 'To replace', value: amtTxt, sub: s.opts.length + ' option' + (s.opts.length > 1 ? 's' : '') + ' below, best first' }],
        lists: lists,
        notes: (s.note ? [s.note] : []).concat(['Swaps change flavor and texture a little. For important bakes, use the ingredient the recipe was written for.'])
      };
      if (v.what === 'vanilla-extract' || v.what === 'vanilla-bean') res.links = [{ href: '/pages/vanilla-bean-to-extract-calculator', text: 'Convert between beans, extract, paste and powder' }];
      if (v.what === 'baking-powder' || v.what === 'baking-soda' || v.what === 'cream-tartar') res.links = [{ href: '/pages/baking-powder-substitute-calculator', text: 'Baking powder & soda substitution guide' }];
      return res;
    }
  });

  /* ===================================================== 5. oven temperature === */

  var GAS = [[0.25, 225], [0.5, 250], [1, 275], [2, 300], [3, 325], [4, 350], [5, 375], [6, 400], [7, 425], [8, 450], [9, 475], [10, 500]];
  function gasFor(f) {
    if (f < 212) return 'below \u00bc';
    var best = GAS[0], err = 1e9;
    GAS.forEach(function (g) { var e = Math.abs(g[1] - f); if (e < err) { err = e; best = g; } });
    return best[0] === 0.25 ? '\u00bc' : best[0] === 0.5 ? '\u00bd' : String(best[0]);
  }
  /** Celsius the way recipes write it: the UK gas-mark table for common temperatures, else the nearest 10. */
  var RECIPE_C = { 225: 110, 250: 120, 275: 140, 300: 150, 325: 170, 350: 180, 375: 190, 400: 200, 425: 220, 450: 230, 475: 240, 500: 260 };
  function recipeC(f) { var k = Math.round(f); return RECIPE_C[k] || Math.round(U.f2c(f) / 10) * 10; }
  function ovenWord(f) {
    if (f < 265) return 'Very cool (slow)';
    if (f < 315) return 'Cool';
    if (f < 340) return 'Moderately slow';
    if (f < 365) return 'Moderate';
    if (f < 390) return 'Moderately hot';
    if (f < 415) return 'Hot';
    if (f < 440) return 'Hot';
    return 'Very hot';
  }
  VGT.tool('oven-temperature-converter', {
    name: 'Oven Temperature Converter',
    units: false,
    fields: [
      { id: 't', type: 'num', label: 'Temperature in the recipe', value: '350', min: 0.25, max: 600,
        unit: { id: 'u', value: 'f', options: [['f', '\u00b0F'], ['c', '\u00b0C'], ['gas', 'Gas mark']] } },
      { id: 'oven', type: 'seg', label: 'The recipe is written for', value: 'std', options: [['std', 'A regular oven'], ['fan', 'A fan or convection oven']] }
    ],
    compute: function (v) {
      var f;
      if (v.u === 'gas') {
        var g = GAS.filter(function (x) { return Math.abs(x[0] - v.t) < 0.01; })[0];
        if (!g) return { error: 'Gas marks run from \u00bc to 10. Enter one of \u00bc, \u00bd, or 1 to 10.' };
        f = g[1];
      } else f = v.u === 'c' ? U.c2f(v.t) : v.t;
      if (v.oven === 'fan') f += 25;
      if (f < 150 || f > 560) return { error: 'That\u2019s outside what home ovens do. Check the number and the unit.' };
      var c = U.f2c(f), fanF = f - 25, c10 = recipeC(f), fanC = c10 - 20;
      var res = {
        cards: [
          { label: 'Regular oven', value: U.fmt(Math.round(f), 0) + '\u00b0F', sub: '= ' + U.fmt(Math.round(c), 0) + '\u00b0C' + (Math.abs(c10 - c) >= 1 ? ' (recipes say ' + c10 + '\u00b0C)' : '') },
          { label: 'Fan or convection oven', value: U.fmt(Math.round(fanF), 0) + '\u00b0F', sub: '= ' + fanC + '\u00b0C fan' },
          { label: 'Gas mark', value: gasFor(f), sub: ovenWord(f) }
        ],
        tables: [{ title: 'Oven temperature chart', head: ['\u00b0F', '\u00b0C', 'Fan \u00b0C', 'Gas', 'Heat'], rows: [250, 275, 300, 325, 350, 375, 400, 425, 450, 475].map(function (x) {
          var cc = recipeC(x);
          return { cells: [x + '\u00b0F', cc + '\u00b0C', (cc - 20) + '\u00b0C', gasFor(x), ovenWord(x)], hl: Math.abs(x - f) < 12.5 };
        }) }],
        notes: ['Fan and convection ovens bake faster: lower the temperature by 25\u00b0F (20\u00b0C), or keep it and check about 25% sooner.',
          'Ovens drift. An oven thermometer on the middle rack tells you what yours really runs at.']
      };
      return res;
    }
  });

  /* ================================================ 6. cake batter & pan fill === */

  var BATTERS = { butter: ['Butter or oil cake', 0.95], sponge: ['Sponge, chiffon or angel food', 0.5], cheese: ['Cheesecake', 1.05],
    brownie: ['Brownie or blondie', 1.12], quick: ['Quick bread or muffin', 1.0] };
  VGT.tool('cake-batter-calculator', {
    name: 'Cake Batter & Pan Fill Calculator',
    fields: panFields('a', 'Pan', 'r9', '2').concat([
      { id: 'batter', type: 'sel', label: 'Batter', value: 'butter', options: Object.keys(BATTERS).map(function (k) { return [k, BATTERS[k][0]]; }) },
      { id: 'fill', type: 'sel', label: 'How full', value: 'auto', options: [['auto', 'Recommended for this pan'], ['0.5', 'Half full'], ['0.6', 'Three-fifths full'], ['0.67', 'Two-thirds full'], ['0.75', 'Three-quarters full']] }
    ]),
    compute: function (v) {
      var p = panFrom(v, 'a'), b = BATTERS[v.batter];
      var fill = v.fill === 'auto' ? (v.batter === 'cheese' ? 0.8 : v.batter === 'sponge' && p.shape === 'ring' ? 0.75 : D.fillFor(p)) : +v.fill;
      var per = p.cups * fill * ML.cup / (p.cavities || 1), total = p.cups * fill * ML.cup * v.an;
      var grams = total * b[1];
      var cards = [
        { label: 'Batter you need', value: U.volA(total), sub: U.mass(grams) + ' of ' + b[0].toLowerCase() + ' batter' },
        { label: p.cavities > 1 ? 'Per cup' : 'Per pan', value: p.cavities > 1 ? U.vol(per) : U.volA(per), sub: 'fill to about ' + U.len(p.depth * fill, 1) + ' deep' }
      ];
      if (p.shape !== 'muffin') cards.push({ label: 'Pan holds (to the rim)', value: U.vol(p.cups * ML.cup), sub: Math.round(fill * 100) + '% full is the target' });
      var notes = [];
      if (v.batter === 'butter' || v.batter === 'quick') {
        var boxes = total / (4.5 * ML.cup), recipes = total / (6 * ML.cup);
        notes.push('That\u2019s about ' + U.frac(boxes, [0, 0.25, 0.5, 0.75, 1]) + ' box' + (boxes > 1.1 ? 'es' : '') + ' of cake mix (each makes 4 to 5 cups) or ' + U.frac(recipes, [0, 0.25, 0.5, 0.75, 1]) + '\u00d7 a typical two-layer cake recipe (about 6 cups of batter).');
      }
      if (fill > 0.7 && v.batter !== 'cheese' && v.batter !== 'sponge') notes.push('Butter cakes rise about 50%. Above two-thirds full, set the pan on a baking sheet in case it spills over.');
      if (v.batter === 'sponge') notes.push('Sponge batters are mostly air, so they weigh about half as much as butter cake batter for the same volume.');
      var t = null;
      if (v.batter !== 'cheese' && v.batter !== 'sponge') {
        t = D.bakeTime(27, D.PANS.r9, 1.0, p, Math.max(0.3, p.depth * fill));
        cards.push({ label: 'Rough baking time at 350\u00b0F', value: rangeMin(t), sub: 'start checking early' });
      }
      return {
        cards: cards,
        notes: notes.concat(['Batter weights are typical values: butter cake batter about 0.95 g per mL, sponge 0.5, cheesecake 1.05, brownie 1.1. Pan volumes are standard chart values.']),
        links: [{ href: '/pages/baking-pan-size-converter?a=' + v.a + '&an=' + v.an, text: 'Compare this pan with another' }, { href: '/pages/cupcake-calculator', text: 'Turn the batter into cupcakes' }]
      };
    }
  });

  /* ============================================== 7. baking time adjustment === */

  VGT.tool('baking-time-calculator', {
    name: 'Baking Time Adjustment Estimator',
    fields: [
      { id: 'a', type: 'sel', label: 'Pan in the recipe', value: 'r9', options: D.panOptions() },
      { id: 'an', type: 'num', label: 'How many', value: '2', min: 1, max: 12 },
      { id: 't', type: 'num', label: 'Recipe\u2019s baking time (minutes)', value: '28', min: 3, max: 300 },
      { id: 'temp', type: 'num', label: 'Oven temperature', value: '350', min: 200, max: 550, unit: { id: 'tu', value: 'f', options: U.TEMP_UNITS } },
      { id: 'b', type: 'sel', label: 'Your pan', value: 'b12', options: D.panOptions() },
      { id: 'bn', type: 'num', label: 'How many', value: '1', min: 1, max: 12 },
      { id: 'mode', type: 'seg', label: 'Batter', value: 'scaled', options: [['scaled', 'I scaled the recipe to fit'], ['same', 'Same batter, different pan']] },
      { id: 'oven', type: 'seg', label: 'Oven', value: 'same', options: [['same', 'Same oven'], ['conv', 'Switching to convection']] }
    ],
    compute: function (v) {
      var a = D.pan(v.a), b = D.pan(v.b), fA = D.fillFor(a), dA = fA * a.depth;
      var tempF = v.tu === 'c' ? U.c2f(v.temp) : v.temp;
      var dB, fullB;
      if (v.mode === 'scaled') { dB = D.fillFor(b) * b.depth; fullB = D.fillFor(b); }
      else {
        var vol = fA * a.cups * v.an; fullB = vol / (b.cups * v.bn); dB = fullB * b.depth;
      }
      var t = D.bakeTime(v.t, a, dA, b, dB), warns = [], notes = [];
      var newTemp = tempF;
      var deep = dB > 2.25 || b.shape === 'ring' || b.shape === 'loaf';
      if (v.oven === 'conv') { newTemp -= 25; t *= 0.9; }
      if (v.mode === 'same' && fullB > 0.78) warns.push('That much batter fills your pan ' + Math.round(fullB * 100) + '% full and will likely overflow. Use another pan or scale the recipe down.');
      if (v.mode === 'same' && fullB < 0.3) warns.push('The batter will be very thin in your pan (' + Math.round(fullB * 100) + '% full). It bakes fast and dries out easily.');
      if (deep && !(a.shape === 'ring' || a.shape === 'loaf')) notes.push('For deep pans, many bakers lower the oven by 25\u00b0F so the edges don\u2019t overbake before the middle sets, and add 10 to 15 minutes. Tent with foil if the top browns too fast.');
      if (v.oven === 'conv') notes.push('Convection: we lowered the temperature by 25\u00b0F and took about 10% off the time. Check from three-quarters of the time.');
      var cards = [
        { label: 'Estimated baking time', value: rangeMin(t), sub: 'at ' + U.temp(U.f2c(newTemp), 5) },
        { label: 'Start checking at', value: U.fmt(Math.max(1, Math.round(t * 0.82)), 0) + ' min', sub: 'then every 3 to 5 minutes' },
        { label: 'Batter depth', value: U.len(dA, 1) + ' \u2192 ' + U.len(dB, 1), sub: dB > dA * 1.05 ? 'deeper, so it bakes longer' : dB < dA * 0.95 ? 'shallower, so it bakes faster' : 'about the same' }
      ];
      return {
        cards: cards, warns: warns,
        lists: [{ title: 'How to tell it\u2019s done', items: [
          'A toothpick in the center comes out clean or with a few moist crumbs.',
          'The top springs back when pressed lightly, and the edges pull away from the pan.',
          'An instant-read thermometer in the center reads 205\u2013210\u00b0F (96\u201399\u00b0C) for cakes, 200\u2013205\u00b0F for quick breads.'] }],
        notes: notes.concat(['This is an estimate. It scales your recipe\u2019s own time by how deep the batter sits and how far heat has to travel from the pan walls; ovens, pan color and batter all change the real time.'])
      };
    }
  });

  /* ======================================================= 8. egg sizes ===== */

  VGT.tool('egg-size-converter', {
    name: 'Egg Size & Egg Weight Converter',
    fields: [
      { id: 'n', type: 'num', label: 'Eggs in the recipe', value: '3', min: 0.25, max: 60, quick: [['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['6', '6']] },
      { id: 'from', type: 'sel', label: 'Size the recipe uses', value: 'large', options: D.EGGS.map(function (e) { return [e.key, e.name]; }) },
      { id: 'to', type: 'sel', label: 'Size you have', value: 'medium', options: D.EGGS.map(function (e) { return [e.key, e.name]; }) }
    ],
    compute: function (v) {
      var A = D.EGG[v.from], B = D.EGG[v.to], need = v.n * A.g, count = need / B.g;
      var cards = [
        { label: 'Use', value: U.eggText(count).replace(/(\d+) egg/, '$1 ' + B.name.toLowerCase().replace(/ \(.*\)$/, '') + ' egg'), sub: U.fmt(count, 2) + ' ' + B.name.toLowerCase().replace(/ \(.*\)$/, '') + ' eggs, exactly' },
        { label: U.fmt(v.n, 2) + ' ' + A.name.toLowerCase().replace(/ \(.*\)$/, '') + ' ' + U.plural(v.n, 'egg'), value: U.gtxt(need), sub: 'beaten, without shells' },
        { label: 'Whites and yolks', value: U.gtxt(need * D.EGG_WHITE) + ' + ' + U.gtxt(need * D.EGG_YOLK), sub: 'about ' + U.kvol(need / 1.03) + ' beaten' }
      ];
      var rows = D.EGGS.filter(function (e) { return e.key.indexOf('uk') !== 0 || v.from.indexOf('uk') === 0 || v.to.indexOf('uk') === 0; }).map(function (e) {
        var c = need / e.g;
        return { cells: [e.name, U.fmt(c, 2), U.eggText(c)], hl: e.key === v.to };
      });
      var ref = D.EGGS.map(function (e) { return [e.name, U.gtxt(e.shell), U.gtxt(e.g), U.gtxt(e.g * D.EGG_WHITE), U.gtxt(e.g * D.EGG_YOLK)]; });
      var notes = [];
      if (v.n <= 2 && Math.abs(A.g - B.g) / A.g < 0.2) notes.push('For one or two eggs, neighboring sizes work fine. From three eggs up, the difference adds up, so swap by weight.');
      notes.push('For exact results, beat the eggs and weigh out ' + U.gtxt(need) + '. Liquid egg from a carton: \u00bc cup per large egg; carton egg whites: 2 tbsp per white.');
      return {
        cards: cards,
        tables: [{ title: 'The same amount of egg in other sizes', head: ['Size', 'Exactly', 'In the kitchen'], rows: rows },
          { title: 'Average weight of one egg', head: ['Size', 'In shell', 'Without shell', 'White', 'Yolk'], rows: ref, note: 'US sizes use USDA minimum weights per dozen; the egg itself is about 88% of the weight in the shell.' }],
        notes: notes
      };
    }
  });

  /* =============================================== 9. sweetener equivalency === */
  /* ratio = cups of this sweetener that replace 1 cup of granulated sugar (common baking guidance);
     liq = cups of recipe liquid to remove per cup of sweetener used; soda = tsp baking soda to add per cup used. */
  var SWEET = [
    ['sugar', 'Granulated sugar', 198, 1, 0, 0, 0, ''],
    ['brown', 'Brown sugar, packed', 213, 1, 0, 0, 0, 'Moister and softer, with a caramel note.'],
    ['superfine', 'Superfine (caster) sugar', 190, 1, 0, 0, 0, 'Dissolves faster; great in meringues and sponges.'],
    ['powdered', 'Confectioners\u2019 sugar', 113, 1.75, 0, 0, 0, 'Contains cornstarch; fine in frostings and shortbread, not ideal in cakes.'],
    ['coconut', 'Coconut sugar', 154, 1, 0, 0, 0, 'Darker and less sweet; bakes a little drier.'],
    ['turbinado', 'Turbinado or demerara', 180, 1, 0, 0, 0, 'Coarse crystals; best for topping or in moist batters.'],
    ['honey', 'Honey', 336, 0.75, 0.25, 0.25, 25, 'Browns faster and keeps baked goods moist.'],
    ['maple', 'Maple syrup', 312, 0.75, 0.25, 0, 25, 'Mild maple flavor; slightly less sweet than honey.'],
    ['agave', 'Agave syrup', 336, 0.667, 0.375, 0, 25, 'About 1\u00bd times as sweet as sugar; browns quickly.'],
    ['molasses', 'Molasses', 340, 1.333, 0.234, 0.375, 0, 'Strong flavor: replace no more than half the sugar.'],
    ['allulose', 'Allulose', 200, 1.333, 0, 0, 25, 'About 70% as sweet; browns faster than sugar.'],
    ['erythritol', 'Erythritol (pure)', 200, 1.333, 0, 0, 0, 'About 70% as sweet with a cool aftertaste; can recrystallize as it cools.'],
    ['monk', 'Monk fruit or stevia 1:1 baking blend', 200, 1, 0, 0, 0, 'Made to measure like sugar; check the package, as blends differ.'],
    ['splenda', 'Sucralose granulated (measures like sugar)', 25, 1, 0, 0, 0, 'Very light: one cup weighs about 25 g. Bakes paler and drier.']
  ];
  var SW = {};
  SWEET.forEach(function (s) { SW[s[0]] = { key: s[0], name: s[1], gpc: s[2], ratio: s[3], liq: s[4], soda: s[5], ovenF: s[6], note: s[7] }; });
  VGT.tool('sugar-substitute-calculator', {
    name: 'Sugar Sweetness Equivalency Calculator',
    fields: [
      { id: 'amt', type: 'num', label: 'Amount in the recipe', value: '1', min: 0.01, max: 1000,
        unit: { id: 'u', value: 'cup', options: [['cup', 'cups'], ['tbsp', 'tablespoons'], ['tsp', 'teaspoons'], ['g', 'grams'], ['oz', 'ounces']] }, quick: QUICK_CUPS },
      { id: 'from', type: 'sel', label: 'Sweetener in the recipe', value: 'sugar', options: SWEET.map(function (s) { return [s[0], s[1]]; }) },
      { id: 'to', type: 'sel', label: 'Sweetener you want to use', value: 'honey', options: SWEET.map(function (s) { return [s[0], s[1]]; }) }
    ],
    compute: function (v) {
      var A = SW[v.from], B = SW[v.to];
      var cupsA = U.UNIT_KIND[v.u] === 'mass' ? v.amt * G[v.u] / A.gpc : v.amt * ML[v.u] / ML.cup;
      var sugarCups = cupsA / A.ratio, cupsB = sugarCups * B.ratio, gB = cupsB * B.gpc;
      var liquidOut = cupsB * B.liq - cupsA * A.liq, soda = cupsB * B.soda - cupsA * A.soda;
      var cards = [{ label: 'Use', value: U.kvol(cupsB * ML.cup) + ' ' + B.name.toLowerCase(), sub: U.mass(gB) }];
      var lists = [];
      var steps = [];
      if (liquidOut > 0.02) steps.push('Use ' + U.kvol(liquidOut * ML.cup) + ' less of the recipe\u2019s other liquid (milk, water or juice).');
      if (liquidOut < -0.02) steps.push('Add ' + U.kvol(-liquidOut * ML.cup) + ' more liquid to make up for the syrup you took out.');
      if (soda > 0.01) steps.push('Add ' + U.kvol(soda * ML.tsp) + ' baking soda to balance the sweetener\u2019s acidity.');
      if (B.ovenF && !A.ovenF) steps.push('Lower the oven by ' + B.ovenF + '\u00b0F (15\u00b0C): it browns faster.');
      if (A.ovenF && !B.ovenF) steps.push('Bake at the oven temperature the recipe gave for sugar.');
      if (steps.length) lists.push({ title: 'Adjust the recipe', items: steps });
      var notes = [];
      if (B.note) notes.push(B.name + ': ' + B.note);
      notes.push('Sugar does more than sweeten: it keeps cakes tender, helps cookies spread and browns crusts. Swaps are starting points, so expect small changes in texture.');
      if (v.to === 'molasses' || v.to === 'allulose' || v.to === 'erythritol' || v.to === 'splenda') notes.push('For the best texture, replace only part of the sugar the first time.');
      return {
        cards: cards.concat([{ label: 'Same sweetness as', value: U.kvol(sugarCups * ML.cup) + ' sugar', sub: U.gtxt(sugarCups * 198) + ' granulated' }]),
        lists: lists,
        tables: [{ title: 'Equal to ' + U.kvol(sugarCups * ML.cup) + ' of granulated sugar', head: ['Sweetener', 'Amount', 'Weight'], rows: SWEET.map(function (s) {
          var c = sugarCups * s[3];
          return { cells: [s[1], U.kvol(c * ML.cup), U.gtxt(c * s[2])], hl: s[0] === v.to };
        }) }],
        notes: notes
      };
    }
  });

  /* ======================================== 10. baking powder & soda guide ===== */

  var TYPES = { cake: ['Cakes and cupcakes', 1, 1.25], muffin: ['Muffins and quick breads', 1.25, 1.75], biscuit: ['Biscuits and scones', 1.5, 2],
    pancake: ['Pancakes and waffles', 1.5, 2], cookie: ['Cookies', 0.25, 0.5] };
  VGT.tool('baking-powder-substitute-calculator', {
    name: 'Baking Powder & Baking Soda Substitution Guide',
    fields: [
      { id: 'mode', type: 'seg', label: 'What do you need?', value: 'bp', options: [['bp', 'I\u2019m out of baking powder'], ['soda', 'I\u2019m out of baking soda'], ['check', 'How much should I use?']] },
      { id: 'bp', type: 'num', label: 'Baking powder in the recipe', value: '2', min: 0.05, max: 40, suffix: 'tsp', show: function (v) { return v.mode === 'bp'; },
        quick: [['0.5', '\u00bd tsp'], ['1', '1 tsp'], ['1.5', '1\u00bd tsp'], ['2', '2 tsp'], ['3', '1 tbsp']] },
      { id: 'soda', type: 'num', label: 'Baking soda in the recipe', value: '1', min: 0.05, max: 20, suffix: 'tsp', show: function (v) { return v.mode === 'soda'; },
        quick: [['0.25', '\u00bc tsp'], ['0.5', '\u00bd tsp'], ['1', '1 tsp']] },
      { id: 'flour', type: 'num', label: 'Flour in the recipe', value: '2', min: 0.1, max: 40, suffix: 'cups', show: function (v) { return v.mode === 'check'; } },
      { id: 'type', type: 'sel', label: 'What you\u2019re baking', value: 'muffin', options: Object.keys(TYPES).map(function (k) { return [k, TYPES[k][0]]; }), show: function (v) { return v.mode === 'check'; } },
      { id: 'acid', type: 'num', label: 'Buttermilk, yogurt or sour cream', value: '1', min: 0, max: 20, suffix: 'cups', show: function (v) { return v.mode === 'check'; },
        help: 'Acidic dairy that baking soda reacts with. Enter 0 if there isn\u2019t any.' }
    ],
    compute: function (v) {
      var tsp = function (x) { return U.kvol(x * ML.tsp); };
      if (v.mode === 'bp') {
        var n = v.bp;
        return {
          cards: [{ label: 'To replace', value: tsp(n) + ' baking powder', sub: 'pick one option below' }],
          lists: [
            { title: 'Baking soda + cream of tartar (closest match)', items: [tsp(n / 4) + ' baking soda', tsp(n / 2) + ' cream of tartar', { html: '<em>Mix right before using and bake promptly; it acts faster than double-acting powder.</em>' }] },
            { title: 'Baking soda + buttermilk or yogurt', items: [tsp(n / 4) + ' baking soda', U.kvol(n / 2 * ML.cup) + ' buttermilk or plain yogurt, used in place of the same amount of the recipe\u2019s liquid'] },
            { title: 'Baking soda + lemon juice or vinegar', items: [tsp(n / 4) + ' baking soda', tsp(n / 2) + ' lemon juice or white vinegar, added with the wet ingredients'] },
            { title: 'Self-rising flour', items: ['Swap ' + U.kvol(n / 1.5 * ML.cup) + ' of the flour for self-rising flour', 'Leave out ' + tsp(n / 1.5 / 4) + ' of the salt'] }
          ],
          notes: ['Baking powder is baking soda plus a dry acid. Each teaspoon has about \u00bc tsp of baking soda in it, which is why these swaps work.']
        };
      }
      if (v.mode === 'soda') {
        var s = v.soda;
        return {
          cards: [{ label: 'Use instead', value: tsp(s * 3) + ' baking powder', sub: 'three times the baking soda' }],
          lists: [{ title: 'What changes', items: ['Baked goods brown less and can taste a little tangy, because the recipe\u2019s acid isn\u2019t neutralized.', 'Cookies spread less and stay paler and softer.', 'Potassium bicarbonate works one for one; add a pinch more salt.'] }],
          notes: ['Baking soda is about four times as strong as baking powder, but powder brings its own acid, so three times as much is the usual swap.']
        };
      }
      var t = TYPES[v.type], lo = t[1] * v.flour, hi = t[2] * v.flour;
      var soda = v.acid * 0.5, bpLo = Math.max(0, lo - soda * 4), bpHi = Math.max(0, hi - soda * 4);
      var range = function (a, b) { return Math.abs(a - b) < 0.05 ? tsp(a) : tsp(a) + ' to ' + tsp(b); };
      var res = {
        cards: [
          { label: 'Baking powder', value: bpHi < 0.05 ? 'None needed' : range(bpLo, bpHi), sub: t[0].toLowerCase() + ', ' + U.fmt(v.flour, 2) + ' cups flour' },
          { label: 'Baking soda', value: soda ? tsp(soda) : 'None needed', sub: soda ? 'for ' + U.kvol(v.acid * ML.cup) + ' acidic dairy' : 'no acidic dairy' }
        ],
        notes: ['Rule of thumb: about ' + U.fmt(t[1], 2) + ' to ' + U.fmt(t[2], 2) + ' tsp baking powder per cup of flour for ' + t[0].toLowerCase() + ', and \u00bd tsp baking soda per cup of buttermilk, yogurt or sour cream. Each \u00bc tsp of soda working with an acid lifts about as much as 1 tsp of baking powder.',
          'Too much leavening tastes soapy or bitter and can make cakes rise and then sink.']
      };
      if (v.type === 'cookie') res.notes.unshift('Cookies use leavening for spread and browning more than lift, so amounts are small.');
      return res;
    }
  });
  /* =============================================== butter converter ===== */
  /* USDA FoodData Central 173410/173430: 1 stick = 113 g, 1 cup = 227 g, 1 tbsp = 14.2 g; salted butter has 643 mg of
     sodium per 100 g. Table salt (173468): 38,800 mg sodium per 100 g, 1 tsp = 6 g. */
  var BUTTER = { stick: 113, cup: 227, tbsp: 14.2, tsp: 14.2 / 3, g: 1, oz: G.oz, lb: G.lb };
  VGT.tool('butter-converter', {
    name: 'Butter Converter',
    fields: [
      { id: 'amt', type: 'num', label: 'Butter', value: '1', min: 0.01, max: 100000, quick: [['0.5', '\u00bd'], ['1', '1'], ['2', '2']],
        unit: { id: 'u', value: 'stick', options: [['stick', 'sticks'], ['cup', 'cups'], ['tbsp', 'tablespoons'], ['tsp', 'teaspoons'], ['g', 'grams'], ['oz', 'ounces'], ['lb', 'pounds']] } },
      { id: 'swap', type: 'chk', label: 'The recipe wants salted butter and I have unsalted', value: false },
      { id: 'na', type: 'num', label: 'Sodium on your salted butter\u2019s label (optional)', value: '', optional: true, min: 0, max: 300, suffix: 'mg per 1 tbsp', show: function (v) { return v.swap; } }
    ],
    compute: function (v) {
      var g = v.amt * BUTTER[v.u], tbsp = g / 14.2, sticks = g / 113;
      var cards = [{ label: 'Weight', value: U.gtxt(g), sub: U.oztxt(g) },
        { label: 'Sticks', value: U.frac(sticks, [0, 0.25, 0.5, 0.75, 1]) + ' ' + (sticks > 1.12 ? 'sticks' : 'stick'), sub: 'a US stick is 113 g' },
        { label: 'Cups', value: U.frac(g / 227, [0, 1 / 8, 1 / 4, 1 / 3, 1 / 2, 2 / 3, 3 / 4, 1]) + ' cup', sub: U.fmt(tbsp, tbsp < 10 ? 1 : 0) + ' tbsp' }];
      var notes = ['Weights are USDA FoodData Central\u2019s: 1 stick = \u00bd cup = 8 tbsp = 113 g.'];
      if (v.swap) {
        var own = isFinite(v.na) && v.na > 0, na = own ? v.na / 14.2 : 6.43, salt = g * na / 388;
        cards.push({ label: 'Add salt', value: U.gtxt(salt), sub: 'about ' + U.frac(salt / 6, [0, 1 / 8, 1 / 4, 1 / 3, 1 / 2, 2 / 3, 3 / 4, 1]) + ' tsp table salt', tone: 'ok' });
        notes.push(own ? 'Salt from your label\u2019s sodium (' + v.na + ' mg per tbsp) \u00f7 the sodium in table salt (388 mg per gram).' : 'Salted butter averages 643 mg sodium per 100 g (USDA); brands vary, so enter your label\u2019s sodium for an exact amount. Table salt is 388 mg sodium per gram and 6 g per teaspoon.');
      }
      return { cards: cards, notes: notes, links: [{ href: '/pages/cups-to-grams-converter?ing=butter', text: 'Other ingredients in grams' }, { href: '/pages/ingredient-substitution-calculator', text: 'Butter substitutes' }] };
    }
  });
})((typeof window !== 'undefined' ? window : globalThis).VGT);
